import React, { Component } from 'react';
import _ from 'lodash';
import { withApollo } from 'react-apollo';
import mapCPTs from '../../utils/mapCPTs';
import { CreateOutgoingEmailMessage } from '../../mutations/CreateOutgoingEmailMessage';
import View from './View';

class EmailResponder extends Component {
  state = {
    paxReplyEmail: '',
    recipient: '',
    selectedAttachments: []
  };

  get recipientValue() {
    const { forward, email } = this.props;
    const { recipient } = this.state;
    return !forward && email ? email.from : recipient;
  }

  handleEmailBodyChange = ({ target }) =>
    this.setState({ paxReplyEmail: target.value });

  handleAttachmentsSelectionChange = attachment => {
    const { selectedAttachments } = this.state;
    this.setState({
      selectedAttachments: _.xor(selectedAttachments, [attachment])
    });
  };

  handleMessageSend = senderEmail => {
    const { client, claim, forward, taskId, onEmailSent, email } = this.props;
    const { paxReplyEmail, selectedAttachments } = this.state;
    const emailId = email ? email.id : '';
    this.setState({ loading: true });
    client
      .mutate({
        mutation: CreateOutgoingEmailMessage,
        variables: {
          input: {
            taskId: Number(taskId),
            emailMessage: {
              claimId: claim ? Number(claim.id) : '',
              from: senderEmail,
              to: this.recipientValue,
              triggeringType: 'manual',
              senderType: email.senderType,
              subject: this.subject(),
              content: paxReplyEmail,
              documentIds: selectedAttachments.map(id => Number(id)),
              [`${forward ? 'forwarded' : 'replied'}EmailMessageId`]: emailId
            }
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        onEmailSent();
      })
      .catch(() => this.setState({ loading: false }));
  };

  subject = () => {
    const { forward, email } = this.props;
    return `${forward ? 'FWD' : 'RE'}: ${email ? email.subject : ''}`;
  };

  handleRecipientChange = recipient => this.setState({ recipient: recipient });

  render = () => {
    const { claim, loading, email } = this.props;
    const { documents } = mapCPTs(claim);
    const emailsArray = email && email.to ? email.to : [];
    const senderEmail = emailsArray.reduce(
      (prev, curr) => (curr.indexOf('airrefund') !== -1 ? curr : prev),
      ''
    );

    return (
      <View
        {...this.state}
        {...this.props}
        documents={documents}
        loading={loading || this.state.loading}
        senderEmail={senderEmail}
        recipient={this.recipientValue}
        onRecipientChange={this.handleRecipientChange}
        onEmailBodyChange={this.handleEmailBodyChange}
        onAttachmentsSelectionChange={this.handleAttachmentsSelectionChange}
        onMessageSend={this.handleMessageSend}
        subject={this.subject()}
      />
    );
  };
}

export default withApollo(EmailResponder);



// WEBPACK FOOTER //
// ./src/component/EmailResponder/index.js